import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CoursesService } from '@services/courses.service';
import { LanguageService } from '@services/language.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-newcourse',
  templateUrl: './newcourse.component.html',
  styleUrls: ['./newcourse.component.css']
})
export class NewcourseComponent implements OnInit {
  definitionForm:FormGroup;
  submitted=false;
  languages:any[]=[];
  @Input() data:any;
  constructor(  private formBuilder:FormBuilder,
    private activeModal:NgbActiveModal,
    private courseService:CoursesService,
    private toastrService:ToastrService,
    private languageService:LanguageService,
    ) { }

  ngOnInit() {
    this.getLangs();

    this.definitionForm=this.formBuilder.group({
      'fromId':['',Validators.required],
      'toId':['',Validators.required]

    });

    if(this.data){

        this.definitionForm.get("fromId").patchValue(this.data.fromId);
        this.definitionForm.get("toId").patchValue(this.data.toId);
      
       
    }

    
  }


  
  getLangs(){
    this.languageService.all().subscribe(res=>{
        this.languages=res;
       
    })
}





save(){

  if(!this.definitionForm.valid){
    this.definitionForm.markAllAsTouched();
    this.toastrService.clear();
    this.toastrService.warning("Lütfen gerekli alanları doldurunuz","Uyarı");
    return;
  }
  this.submitted=true;

  if(this.data){

    this.courseService.update(this.data.id,this.definitionForm.value).subscribe(res=>{

      this.toastrService.clear();
      this.toastrService.success("Kurs güncelleme başarılı","İşlem Başarılı");
      this.definitionForm.reset();
      this.submitted=false;
    },err=>{
      this.submitted=false;
      this.toastrService.clear();
      this.toastrService.error("Kayıt sırasında hata oluştu","Hata");
    });


  }else{
    this.courseService.add(this.definitionForm.value).subscribe(res=>{

      this.toastrService.clear();
      this.toastrService.success("Kurs ekleme başarılı","İşlem Başarılı");
      this.definitionForm.reset();
      this.submitted=false;
    },err=>{
      this.submitted=false;
      this.toastrService.clear();
      this.toastrService.error("Kayıt sırasında hata oluştu","Hata");
    });
  }



}

close(){
  this.activeModal.close();
}



}
